<style lang="css">
@font-face {
  font-family: "GothamBold";
  font-style: normal;
  font-weight: 400;
  src: local("Gotham Bold"),
    url(../../website_20/static/font/Gotham/Gotham-Bold.woff) format("woff");
}

@font-face {
  font-family: "GothamLight";
  font-style: normal;
  font-weight: 400;
  src: local("Gotham Light"),
    url(../../website_20/static/font/Gotham/Gotham-Light.woff) format("woff");
}

@font-face {
  font-family: "GothamBook";
  font-style: normal;
  font-weight: 400;
  src: local("Gotham Book"),
    url(../../website_20/static/font/Gotham/Gotham-Book-Regular.otf)
      format("opentype");
}

@font-face {
  font-family: OpenSans;
  font-style: normal;
  font-weight: 400;
  src: local("OpenSans Regular"),
    url(../../website_20/static/font/OpenSans/OpenSans-Regular.ttf)
      format("truetype");
}

body,
html {
  padding: 0;
  margin: 0;
  font-size: 100px;
  font-family: GothamBook;
}

input,
input:focus,
button,
button:focus {
  outline: none;
}

.el-header.search {
  font-size: 0.18rem;
  text-align: center;
  line-height: 80px;
}

div {
  font-size: 0.14rem;
}
p {
  margin: 0;
  padding: 0;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
#app {
  position: relative;
}
</style>

<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import SearchResult from "@/components/SearchResult";
import Reservation from "@/components/Reservation";

export default {
  name: "app"
};
</script>



// WEBPACK FOOTER //
// src/App.vue